import { Visualize3dObject, getComponent } from '../../models/visualize3d-object';
import type { TransformComponent } from '../transform-component';
import { OnObject3dInit } from '../../view-interactions/object-3d-events';
import { Injectable } from '@angular/core';
import { Matrix4, Object3D } from 'three';

@Injectable({
  providedIn: 'root',
})
export class TransformComponentHandler implements OnObject3dInit {
  initialize(object3d: Object3D, v3dObject: Visualize3dObject): void {
    const component = getComponent<TransformComponent>(v3dObject, 'Transform');
    if (!component) {
      return;
    }
    const matrix = new Matrix4();
    matrix.set(
      component.matrix.m11,
      component.matrix.m21,
      component.matrix.m31,
      component.matrix.m41,
      component.matrix.m12,
      component.matrix.m22,
      component.matrix.m32,
      component.matrix.m42,
      component.matrix.m13,
      component.matrix.m23,
      component.matrix.m33,
      component.matrix.m43,
      component.matrix.m14,
      component.matrix.m24,
      component.matrix.m34,
      component.matrix.m44,
    );
    object3d.applyMatrix4(matrix);
    object3d.updateMatrixWorld(true);
  }
}
